import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import Pagination from "../../assets/Pagination";
import {toast} from "react-toastify";
import StationAPI from "../../../apis/adminApi/stationAPI";
import TableLoader from "../../loaders/TableLoader";

const StationsIndex = () => {

    const [stations, setStations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    //Permet d'aller recuperer les invoices
    const fetchStations = async () => {
        try{
            const data =  await StationAPI.findAll();
            setStations(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des stations !");
        }
    };



    //Au chargement du comstationant on va chercher les stations
    useEffect(() => {
        fetchStations();
    }, []);


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des stations en fonction de la recherche

    const filteredStations = stations.filter(
        p =>
            p.station_name.toLowerCase().includes(search.toLowerCase()) ||
            p.station_city.toLowerCase().includes(search.toLowerCase()) ||
            p.station_address.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedStations = Pagination.getData(
        filteredStations,
        currentPage,
        itemsPerPage
    );

    let counter = 1;



    return (
        <>
            <div className="pagetitle">
                <h1>Les stations</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Les Stations essence KKS</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {stations ? stations.length : 0}</h5>
                                    </div>
                                    <div className="col-6">
                                        <Link className="btn btn-sm btn-primary mt-3 d-block" to="/admin/stations/add">
                                            <i className="bi bi-plus-circle"></i> Ajouter un estation
                                        </Link>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input autoComplete="off" type="text" onChange={handleSearch} value={search} className="form-control" placeholder="Rechercher ..." />
                                </div>
                                <table className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Ville</th>
                                        <th scope="col">Adresse</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedStations.map((station) => (
                                        <tr key={station.id}>
                                            <th scope="row">{station.id}</th>
                                            <td>{station.station_name}</td>
                                            <td>{station.station_city}</td>
                                            <td>{station.station_address}</td>

                                            <td>
                                                {station.id === 1 ? <Link className="btn btn-sm btn-outline-primary mx-1 disabled" to={`/admin/stations/edit/${station.id}`}>
                                                    <i className="bi bi-pen-fill"></i>
                                                </Link> : <Link className="btn btn-sm btn-outline-primary mx-1" to={`/admin/stations/edit/${station.id}`}>
                                                    <i className="bi bi-pen-fill"></i>
                                                </Link>}
                                            </td>
                                        </tr>
                                    ))
                                    }
                                    </tbody>}
                                </table>
                                {loading && <TableLoader width={300} height={350} />}

                                {itemsPerPage < filteredStations.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredStations.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default StationsIndex;
